"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ControlledAccordion = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

var _snakeCase2 = _interopRequireDefault(require("lodash/snakeCase"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PanelGroup = _interopRequireDefault(require("react-bootstrap/lib/PanelGroup"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _accordionItem = _interopRequireWildcard(require("./accordion-item"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BaseAccordion = function BaseAccordion(_ref) {
  var AccordionItemComponent = _ref.AccordionItemComponent,
      analytics = _ref.analytics,
      enableAnalytics = _ref.enableAnalytics,
      enableTracking = _ref.enableTracking,
      id = _ref.id,
      items = _ref.items,
      sectionCategory = _ref.sectionCategory;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classes["default"])('border-top-1', 'border-neutral-lighter', 'margin-horizontal-0')
  }, /*#__PURE__*/_react["default"].createElement(_PanelGroup["default"], {
    id: id
  }, items.map(function (_ref2, index) {
    var key = _ref2.key,
        item = _objectWithoutProperties(_ref2, ["key"]);

    return /*#__PURE__*/_react["default"].createElement(AccordionItemComponent, _extends({
      analytics: analytics,
      id: "".concat(id, "_").concat(key || (0, _snakeCase2["default"])(item.title)),
      index: index,
      onSelect: item.onSelect,
      enableAnalytics: enableAnalytics,
      enableTracking: enableTracking,
      key: key || (0, _snakeCase2["default"])(item.title),
      sectionCategory: sectionCategory
    }, item));
  })));
};

BaseAccordion.propTypes = {
  /**
   * Which AccordionItem component to use (ie. AccordionItem or ControlledAccordionItem)
   */
  AccordionItemComponent: _propTypes["default"].oneOf([_accordionItem["default"], _accordionItem.ControlledAccordionItem]).isRequired,

  /**
   * Whether we would like dispatch when bedrock analytics when the panel is expanded or collapsed.
   * @deprecated  Use the enabled flag the analytics prop.
   */
  enableAnalytics: _propTypes["default"].bool,

  /**
   * The content used by that analytics module and the flag to determine if analytics is sent
   */
  analytics: _propTypes["default"].shape({
    enabled: _propTypes["default"].bool,
    payload: _propTypes["default"].shape({
      elementName: _propTypes["default"].string,
      sectionName: _propTypes["default"].string,
      sectionPosition: _propTypes["default"].number
    })
  }),

  /**
   * Flag to indicate if we should fire element interaction events from this Accordion. See the
   * tracking element shape in AccordionItem.
   */
  enableTracking: _propTypes["default"].bool,

  /**
   * Unique identifier supplied to Bootstrap PanelGroup. In order to properly initialize
   * the PanelGroup in a way that is accessible to assistive technologies (such as screen readers) an `id`
   * is required.
   */
  id: _propTypes["default"].string.isRequired,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /**
     * The AccordionItem content.
     */
    children: _propTypes["default"].node.isRequired,

    /**
     * The key to be used for rendering. If not provided, the snake-cased title will be used.
     * Note: this is required if `title` is not a string.
     */
    key: function key(props, propName, componentName) {
      var key = props[propName],
          title = props.title;

      if (typeof title !== 'string' && !key) {
        return new Error("Prop ".concat(propName, " is required when \"title\" is not a string for ").concat(componentName));
      }

      return null;
    },

    /**
     * Callback to be invoked when an AccordionItem is selected.
     */
    onSelect: _propTypes["default"].func,

    /**
     * The header string of the AccordionItem.
     */
    title: _propTypes["default"].node.isRequired
  })).isRequired,

  /**
   * Used for element interaction tracking to indicate where on page the Accordion is.
   */
  sectionCategory: _propTypes["default"].string
};
BaseAccordion.defaultProps = {
  analytics: {
    enabled: false
  },
  enableAnalytics: false,
  enableTracking: false,
  sectionCategory: null
};

var Accordion = function Accordion(props) {
  return /*#__PURE__*/_react["default"].createElement(BaseAccordion, _extends({
    AccordionItemComponent: _accordionItem["default"]
  }, props));
};

Accordion.displayName = 'Accordion';

var ControlledAccordion = function ControlledAccordion(props) {
  return /*#__PURE__*/_react["default"].createElement(BaseAccordion, _extends({
    AccordionItemComponent: _accordionItem.ControlledAccordionItem
  }, props));
};

exports.ControlledAccordion = ControlledAccordion;
ControlledAccordion.displayName = 'ControlledAccordion';
var _default = Accordion;
exports["default"] = _default;